






















































const namespace = 'calendar';
import { Vue, Prop, Component } from 'vue-property-decorator';
import SingleActivity from '@/modules/calendar/components/locations/SingleActivity.vue';
import CalendarTimeline from '@/modules/calendar/components/CalendarTimeline.vue';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { hourToNumber } from '@/utils/time';
import { Getter } from 'vuex-class';

@Component({
    name: 'SingleLocation',
    components: {
        SingleActivity,
        CalendarTimeline,
    },
})
export default class SingleLocation extends Vue {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() public eventsInLocation!: any;
    @Prop() public hoursRange!: number[];
    @Prop() private countLocationsAndEvents!: { countEvents: number; countLocations: number };
    @Prop() private boxType!: string;
    @Prop() private customBoxWidth!: string;
    @Getter('locationWidth', { namespace }) private locationWidth!: number;
    @Getter('boxWidth', { namespace }) private boxWidth!: number;
    @Getter('cellHeight', { namespace }) private cellHeight!: number;
    @Getter('isMobile', { namespace }) private isMobile!: number;

    private get mobileView() {
        return this.isMobile;
    }

    private get classRoomsInLocation() {
        const classroomsIds = [...new Set([...this.eventsInLocation.events].map((e: ICalendarData) => e.ClassroomId))];
        return classroomsIds;
    }

    private get events() {
        return this.eventsInLocation;
    }

    private get hours() {
        return this.hoursRange;
    }

    private get mobileHours() {
        return this.hoursRange.filter(h =>
            [...this.eventsInLocation.events].find((e: ICalendarData) => hourToNumber(e.StartTime) === h),
        );
    }

    private get getBoxType() {
        return this.boxType;
    }

    private get getCustomBoxWidth() {
        return this.customBoxWidth;
    }

    private get cellHeightStyle() {
        return `height: ${this.cellHeight}px`;
    }

    private getEventInClassroom(hour: number, classroomId: number) {
        return this.eventsInHour(hour).find((event: ICalendarData) => event.ClassroomId === classroomId);
    }

    private calculateMobileBoxShift(hour: number, classroomId: number): number {
        const eventsInCurrentHour = this.eventsInHour(hour);
        const numberOfBoxesAlreadyDrown = eventsInCurrentHour?.filter((event: any) => event.ClassroomId < classroomId)
            .length;
        const roomsInLocation = [
            ...new Set(this.eventsInLocation.events.map((event: ICalendarData) => event.ClassroomId)),
        ];
        const currentBoxIndex = roomsInLocation.indexOf(classroomId) + 1;
        const boxShift = currentBoxIndex - numberOfBoxesAlreadyDrown - 1;

        return boxShift <= 0 ? 0 : this.boxWidth * boxShift;
    }

    private eventsInHour(hour: number): ICalendarData[] {
        const realEvents = this.eventsInLocation.events.filter((event: ICalendarData) => {
            const eventStart = hourToNumber(event.StartTime);
            return eventStart >= hour && eventStart < hour + 0.5;
        });
        if (realEvents.lenght === 0) {
            return [];
        }

        return realEvents;
    }

    private get getCountLocationsAndEvents() {
        return this.countLocationsAndEvents;
    }
}
